// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1P-TU","modalForm":"UpgradeEpcsModal_modalForm__18ADW","modalFooter":"UpgradeEpcsModal_modalFooter__VR7io"};